import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { BaivietAction } from 'src/actions/baiviet.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getTintucStatus } from 'src/utils/utils';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import iconMobifone from "../../assets/images/operators/mobifone.jpg";
import iconVinaphone from "../../assets/images/operators/vinaphone.jpg";
import iconViettel from "../../assets/images/operators/viettel.png";

const TheHomepageGoicuoc5gDetail = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const [selectedTintucIds, setSelectedTintucIds] = useState([]);
  const [homepageTintucLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageTintucPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageTintucItems, homepageTintucTotal, homepageTintucFilter } = useSelector(state => state.baiviet);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])
  
  useEffect(() => {
    const payload = {
      ...homepageTintucFilter,
      homepageTintucLimit: homepageTintucLimit,
      homepageTintucPage: homepageTintucPage,
    };
    dispatch(BaivietAction.updateHomepageTintucFilter(payload));
    dispatch(BaivietAction.homepageTintucList())
  }, [homepageTintucPage, homepageTintucLimit])

  const handleSelectAll = (event) => {
    let newSelectedTintucIds;

    if (event.target.checked) {
      newSelectedTintucIds = homepageTintucItems.map((baiviet) => baiviet.id);
    } else {
      newSelectedTintucIds = [];
    }

    setSelectedTintucIds(newSelectedTintucIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedTintucIds.indexOf(id);
    let newSelectedTintucIds = [];

    if (selectedIndex === -1) {
      newSelectedTintucIds = newSelectedTintucIds.concat(selectedTintucIds, id);
    } else if (selectedIndex === 0) {
      newSelectedTintucIds = newSelectedTintucIds.concat(selectedTintucIds.slice(1));
    } else if (selectedIndex === selectedTintucIds.length - 1) {
      newSelectedTintucIds = newSelectedTintucIds.concat(selectedTintucIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedTintucIds = newSelectedTintucIds.concat(
        selectedTintucIds.slice(0, selectedIndex),
        selectedTintucIds.slice(selectedIndex + 1)
      );
    }

    setSelectedTintucIds(newSelectedTintucIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, baiviet) => {
    setSelected(baiviet);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(BaivietAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(BaivietAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageTintucTotal / homepageTintucLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageTintucPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageTintucPage - 2); i <= Math.min(totalPages - 1, homepageTintucPage + 2); i++) {
              pages.push(i);
          }
          if (homepageTintucPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageTintucPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageTintucPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageTintucPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  return (
    <>
        <Helmet>
            <title>Gói cước 5G | Kho số - Di Dong Telecom</title>
        </Helmet>

        <div className='post-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "20px" }}>
            <a className='baiviet-item simvip' href={`https://goicuoc5g.didongtelecom.vn/trang-chu/goi-cuoc/mobifone`} target='_blank' rel="noopener noreferrer" onClick={scrollToTop} onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                <img src={iconMobifone} alt={`GÓI CƯỚC 5G MOBIFONE`}  style={{ width: "30%", height: "100px", objectFit: "cover" }} />
                <div style={{width: "70%"}}>
                    <div className="title">GÓI CƯỚC 5G MOBIFONE</div>
                    <div className="short-description">Chọn và đăng ký ngay gói cước phù hợp nhất với bạn...</div>
                </div>
            </a>
            <a className='baiviet-item simvip' href={`https://goicuoc5g.didongtelecom.vn/trang-chu/goi-cuoc/vinaphone`} target='_blank' rel="noopener noreferrer" onClick={scrollToTop} onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                <img src={iconVinaphone} alt={`GÓI CƯỚC 5G VINAPHONE`}  style={{ width: "30%", height: "100px", objectFit: "cover" }} />
                <div style={{width: "70%"}}>
                    <div className="title">GÓI CƯỚC 5G VINAPHONE</div>
                    <div className="short-description">Chọn và đăng ký ngay gói cước phù hợp nhất với bạn...</div>
                </div>
            </a>
            <a className='baiviet-item simvip' href={`https://goicuoc5g.didongtelecom.vn/trang-chu/goi-cuoc/viettel`} target='_blank' rel="noopener noreferrer" onClick={scrollToTop} onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                <img src={iconViettel} alt={`GÓI CƯỚC 5G VIETTEL`}  style={{ width: "30%", height: "100px", objectFit: "cover" }} />
                <div style={{width: "70%"}}>
                    <div className="title">GÓI CƯỚC 5G VIETTEL</div>
                    <div className="short-description">Chọn và đăng ký ngay gói cước phù hợp nhất với bạn...</div>
                </div>
            </a>
        </div>
    </>
  );
};

export default TheHomepageGoicuoc5gDetail;
